import "core-js/stable";
import './dev.scss';
import { app } from './initApp';

if (process.env.NODE_ENV !== 'production') {
   console.log('Looks like we are in development mode!');
 }

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

document.addEventListener("readystatechange", function(event){
  if (document.readyState === "complete") {
    if (isIE11) {
      document.getElementById("load-text").innerText = "Unsupported Browser";
      document.getElementById("load-counter").classList.add("warning");
      document.getElementById("load-counter").innerHTML = "This browser is not supported. To use this interactive, please access the page with a modern of a major browser such as Safari, Google Chrome, Mozilla Firefox, or Microsoft Edge."
    
    } else {
      app();  
    }  
  }
});